/**
 * Search box for the Vouchers / Redemptions report (Redemptions.tsx).
 *
 * The server (get_redemptions_page / get_redemptions_export, migration 2026-10-06-370) matches the term against the
 * voucher code, the email, and the business by name: the business that issued the voucher (its organization CTA,
 * the event it belongs to, or the store it was issued for) or the business that redeemed it. The hint says exactly that.
 */
import React from "react";

export const REDEMPTIONS_SEARCH_PLACEHOLDER = "Code, email or business";
export const REDEMPTIONS_SEARCH_HINT =
  "Matches the voucher code, the email, or the business that issued or redeemed the voucher (type 3+ letters of a business name).";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const RedemptionsReportSearchField: React.FC<Props> = ({ value, onChange }) => (
  <div>
    <label
      htmlFor="redemptions-report-search"
      className="block text-sm font-medium text-gray-700 mb-1"
    >
      Search
    </label>
    <input
      id="redemptions-report-search"
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={REDEMPTIONS_SEARCH_PLACEHOLDER}
      aria-describedby="redemptions-report-search-hint"
      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary-500"
    />
    <p
      id="redemptions-report-search-hint"
      className="mt-1 text-xs text-gray-500"
    >
      {REDEMPTIONS_SEARCH_HINT}
    </p>
  </div>
);

export default RedemptionsReportSearchField;
